import React, { useState, useEffect } from 'react'
import styles from './styles.module.sass'


const TermsPDF = (props) => {
    const {
        valueComplete,
        showFormActive,
        showForm,
        handleSubmit
    } = props

    
    const contrato_virtual = 'https://resources.sears.com.mx/medios-plazavip/swift/v1/mesaRegalos/CONTRATO-PLAN-VIRTUAL.pdf'
    const contrato_fisica = 'https://resources.sears.com.mx/medios-plazavip/swift/v1/mesaRegalos/CONTATO-PLAN-LO-QUIERO.pdf'
    
    const [ urlTerms, setUrlTerms ] = useState()
    
    
    const [ aceptTerms, setAceptTerms ] = useState(false)
    useEffect(()=>{
        if(!showFormActive){
            setAceptTerms(false)
            document.querySelector('#checkAcept').checked = false
        }
    },[showFormActive])

    useEffect(()=>{
        if(valueComplete?.select_plan?.plan === 1){
            setUrlTerms(contrato_fisica)
        }else if(valueComplete?.select_plan?.plan === 2){
            setUrlTerms(contrato_virtual)
        }

    },[valueComplete])

    const handleChecked = (event) => {
        const { checked } = event?.target
        setAceptTerms(checked)
    }

    return( 
        <>        
            <iframe 
                src={urlTerms}
                className={styles?.iframeTerms}
                loading="lazy"
                frameBorder="0"
                title="PDF-file"
            />
            <div>
                <label htmlFor='checkAcept' className={styles?.checkAcepted}>
                    <input id='checkAcept' type="checkbox" onChange={(event) => handleChecked(event)}/>
                    <p>Acepto términos y condiciones</p>
                </label>
            </div>
            <div className="table_flow_buttons mt-2">
                <div 
                    onClick={showForm}
                    className="btn-with-shadow btn btn-secondary"
                    aria-hidden
                >Atras</div>
                <button 
                    onClick={aceptTerms ? handleSubmit : null}
                    className={aceptTerms ? 'btn-with-shadow btn btn-primary' : 'btn-with-shadow btn btn-primary disabled' } 
                    aria-hidden
                    type="submit"
                >Siguiente</button>
            </div>
        </>
    )
}

export default TermsPDF